import { SET_CALENDAR_PRICING_MAP } from '../../actions/actionTypes'

const calendarPricingMap = (state = [], action) => {
  switch (action.type) {
    case SET_CALENDAR_PRICING_MAP:
      return Object.assign([], state, action.calendarPricingMap)
    default:
      return state
  }
}

export { calendarPricingMap }
